import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=db973390&scoped=true&"
import script from "./StaffList.vue?vue&type=script&lang=js&"
export * from "./StaffList.vue?vue&type=script&lang=js&"
import style0 from "./StaffList.vue?vue&type=style&index=0&id=db973390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db973390",
  null
  
)

export default component.exports